import { render, staticRenderFns } from "./workflow-feedback-status-table-item.vue?vue&type=template&id=e3fbe764"
import script from "./workflow-feedback-status-table-item.vue?vue&type=script&lang=js"
export * from "./workflow-feedback-status-table-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports